import React from 'react';
import { Container, Table, Title } from './styled';
import { observer } from 'mobx-react';
import style from '../../../../../routes/score/baseball/match/summary/style.module.scss';

const PitcherTable = observer(({ data }) => {
  return (
    <Container>
      <Title>투수 기록</Title>
      <Table>
        <thead>
          <tr>
            <th>선수명</th>
            <th>이닝</th>
            <th>투구수</th>
            <th>피안타</th>
            <th>피홈런</th>
            <th>볼넷</th>
            <th>삼진</th>
            <th>실점</th>
            <th>자책점</th>
            <th>오늘 평자책</th>
            <th>시즌 평자책</th>
          </tr>
        </thead>
        <tbody>
          {data.map((value, key) => {
            const {
              player,
              inningPitched,
              pitchCount,
              hit,
              homeRun,
              baseOnBalls,
              strikeOuts,
              run,
              earnedRun,
              todayEarnedRunAverage,
              earnedRunAverage
            } = value;
            return (
              <tr key={key}>
                <td className={style.player}>{player.displayName}</td>
                <td className={style.row}>{inningPitched}</td>
                <td className={style.row}>{pitchCount}</td>
                <td className={style.row}>{hit}</td>
                <td className={style.row}>{homeRun}</td>
                <td className={style.row}>{baseOnBalls}</td>
                <td className={style.row}>{strikeOuts}</td>
                <td className={style.row}>{run}</td>
                <td className={style.row}>{earnedRun}</td>
                <td className={style.rowAvg}>{todayEarnedRunAverage}</td>
                <td className={style.rowAvg}>{earnedRunAverage}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
});

export default PitcherTable;
